import { Component, Input, OnChanges } from '@angular/core';
import { environment } from '../../../environments/environment'

@Component({
  selector: 'app-preview-button',
  templateUrl: './app-preview-button.component.html',
  styleUrls: ['./app-preview-button.component.scss']
})
export class AppPreviewButtonComponent implements OnChanges {

  public previewUrl = '';

  @Input() type: string;
  @Input() id: number;
  @Input() slug: string;
  @Input() employerSlug: string;
  @Input() employerId: string;
  @Input() country: 'it' | 'en' | 'es' | 'fr';

  public isEnabled = true;

  constructor() {
  }

  ngOnChanges() {
    if ((this.id || this.slug) && this.type) {
      this.setupUrl(this.id, this.type);
    }
  }

  public openPreview() {
    console.log('Opening preview:', this.previewUrl);
    window.open(this.previewUrl, '_blank');
  }

  private setupUrl(id: number, type: string): void {
    let url = environment.baseUrlV3;
    this.isEnabled = true;
    switch (type) {
      case 'joboffers':
        url += '/preview/job-offer/';
        break;
      case 'articles':
        url += '/preview/post/';
        break;
      case 'polls':
        url = null;
        this.isEnabled = false;
        break;
      case 'events':
        url = null;
        this.isEnabled = false;
        break;
      case 'profile':
        url += '/preview/profile/';
        break;
      case 'webinar': {
        url += '/preview/experience/';
        break;
      }
      // case 'joboffers':
      //   url += '/' + this.country + '/preview/job-offer/';
      //   break;
      // case 'articles':
      //   url += '/' + this.country + '/preview/article/';
      //   break;
      // case 'polls':
      //   url += '/' + this.country + '/preview/article/';
      //   break;
      // case 'events':
      //   url += '/' + this.country + '/e/';
      //   break;
      // case 'profile':
      //   url += '/' + this.country + '/preview/profile/';
      //   break;
      // case 'webinar': {
      //   url += '/' + this.country + '/experiences/';
      //   break;
      // }
    }
    if (this.type !== 'profile') {
      this.previewUrl = url + id;
    } else {
      this.previewUrl = `${url}${this.employerId || ''}`;
    }
  }
}
